import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { Checkbox } from '@mui/material';

type Props = {
  onGroupToggle: (index: number) => void;
  getAmenities: (amenities: Array<App.Amenity>) => string;
  getEditUrl: (id: string) => string;
  value: {
    index: number;
    group: App.AmenityGroup & { checked: boolean };
  };
};

export default function SortableItem({ onGroupToggle, getAmenities, getEditUrl, value }: Props) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: value.group.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <li
      {...attributes}
      {...listeners}
      ref={setNodeRef}
      style={style}
      className="sortable-amenity-group"
      data-list-order={value.group.order}
    >
      <div className="sortable-amenity-group-inner">
        <div className="sortable-amenity-group-inner-left">
          <Checkbox checked={value.group.checked} onChange={(event) => onGroupToggle(value.index)} />
          <div className="sortable-amenity-group-index">{value.index + 1}.</div>{' '}
          <div className="sortable-amenity-group-location"> {value.group.name} </div>
          <span>&nbsp;| {getAmenities(value.group.amenities)} </span>
        </div>
        <div className="sortable-amenity-group-inner-right">
          <div className="sortable-amenity-group-link">
            <a href={getEditUrl(value.group.id)} target="_blank" rel="noreferrer">
              Edit
            </a>
          </div>
        </div>
      </div>
    </li>
  );
}
